const init = () => {
  var licensePoint = $('.company-license-nav-item');
  var licenseBox = $('.company-license-box');
  licensePoint.on('click', function () {
    var catData = $(this).data('tab')
    licensePoint.removeClass('is-active')
    $(this).addClass('is-active')
    licenseBox.removeClass('is-active')
    $(`.company-license-box[data-content="${catData}"]`).addClass('is-active')
    if ($(window).width() < 1023) {
      $(`.company-license-box[data-content="${catData}"]`).slick('setPosition');
    }
  });
}

export default {
  init
};